import { trpc } from '@tg/app-core';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { D, MONTHS, MONTHS_N, RU, dowMon, iso } from '../lib/dates';
import { I } from './icons';
import { useLeave } from './overlay';

/* Окно выбора даты (H0): месяц сеткой, точка статуса дня — запланирована
   (оранжевая), выполнена (зелёная), пропущена (красная), отдых. Неделя — с понедельника. */
const DAYST = { plan: 'Запланирована', done: 'Выполнена', skip: 'Пропущена', rest: 'Отдых' } as const;
export type DaySt = keyof typeof DAYST;
type St = DaySt;
type CalDay = { has: number; comp: boolean; done: boolean };

/** Статус дня по ответу clientApp.calendar: тот же в окне месяца и в полосе недели */
export function dayStatus(x: CalDay | undefined, date: string, today: string): DaySt {
  if (!x || (!x.has && !x.comp)) return 'rest';
  if (x.done) return 'done';
  return date < today ? 'skip' : 'plan';
}

export function MonthCal({ open, sel, today, onPick, onClose }: { open: boolean; sel: string; today: string; onPick: (d: string) => void; onClose: () => void }) {
  const { mounted, out } = useLeave(open, 180);
  const [m, setM] = useState(() => sel.slice(0, 7));
  const [y, mo] = m.split('-').map(Number);
  const first = `${m}-01`;
  const n = new Date(y, mo, 0).getDate();
  const last = `${m}-${String(n).padStart(2, '0')}`;
  const cal = trpc.clientApp.calendar.useQuery({ from: first, to: last }, { enabled: mounted });
  if (!mounted) return null;
  const by = new Map((cal.data || []).map((d) => [d.date, d]));
  const status = (date: string): St => dayStatus(by.get(date), date, today);
  const shift = (k: number) => {
    const d = new Date(y, mo - 1 + k, 1);
    setM(iso(d).slice(0, 7));
  };
  const pick = (d: string) => {
    onPick(d);
    onClose();
  };
  return createPortal(
    <div className={'calw' + (out ? ' out' : '')}>
      <div className="calbg" onClick={onClose} />
      <div className="cal" role="dialog" aria-label="Выберите дату">
        <div className="calh">
          <b>Выберите дату</b>
          <button className="calx" onClick={onClose} aria-label="Закрыть">
            <I n="x" />
          </button>
        </div>
        <div className="calm">
          <button className="caln" onClick={() => shift(-1)} aria-label="Прошлый месяц">
            <I n="left" />
          </button>
          <div>
            <b>{MONTHS_N[mo - 1]}</b>
            <s>{y}</s>
          </div>
          <button className="caln" onClick={() => shift(1)} aria-label="Следующий месяц">
            <I n="right" />
          </button>
        </div>
        <div className="calwd">
          {RU.map((d) => (
            <span key={d}>{d}</span>
          ))}
        </div>
        <div className="calg">
          {Array.from({ length: dowMon(first) }, (_, k) => (
            <i key={'l' + k} />
          ))}
          {Array.from({ length: n }, (_, k) => {
            const date = iso(new Date(y, mo - 1, k + 1));
            const st = status(date);
            return (
              <button
                key={date}
                className={(date === sel ? 'on' : '') + (date === today ? ' today' : '')}
                aria-label={`${k + 1} ${MONTHS[D(date).getMonth()]}, ${DAYST[st].toLowerCase()}`}
                onClick={() => pick(date)}
              >
                <span>{k + 1}</span>
                <i className={st} />
              </button>
            );
          })}
        </div>
        <div className="call">
          {(Object.keys(DAYST) as St[]).map((k) => (
            <span key={k}>
              <i className={k} />
              {DAYST[k]}
            </span>
          ))}
        </div>
        <div className="calb">
          <button className="btn sec" onClick={() => pick(today)}>
            Сегодня
          </button>
          <button className="btn sec" onClick={onClose}>
            Закрыть
          </button>
        </div>
      </div>
    </div>,
    document.getElementById('dev') || document.body,
  );
}
